/**
 * A doctor should only be visible on the public site when the admin's
 * "Status" toggle is Active AND the "Approved" toggle is Yes (Doctors →
 * admin list page). Some API responses omit one of these fields depending
 * on the endpoint, so a missing field is treated as "not disqualifying"
 * rather than hiding the doctor — we only hide on an explicit Inactive/No.
 */
export const isDoctorPublic = (d) => {
  if (!d) return false;
  const statusOk = d.status === undefined || d.status === null || d.status === "Active";
  const approvedOk = d.is_approved === undefined || d.is_approved === null || d.is_approved === "Yes";
  return statusOk && approvedOk;
};

export default isDoctorPublic;
